import type {ConferenceUserWithStatus} from "@inpriton/types";
import React, {useContext} from "react";
import AppContext from "../../context/AppContext";
import MediaContext from "../../context/MediaContext";
import MaterialIcon from "../icons/MaterialIcon";

import './UserStatusSymbols.scss'
import SVGIcon from "../icons/SVGIcon";
import IconInterface from "../icons/IconInterface";

export default ({ user }: { user: ConferenceUserWithStatus }) => {
  const {
    userData,
    typingUsers,
  } = useContext(AppContext)

  const {
    videoEnabled,
    audioEnabled,
    cameraUnavailable,
    micUnavailable,
    micOsMuted,
  } = useContext(MediaContext)

  const isSelf = user.uuid === userData?.uuid

  // RISKS.md/P2.34: for ourselves a chip means "no media", so the self branches read INTENT AND
  // DEVICE — the toggle flags are written by the buttons and by nothing that fails. Keep `hasVideo`
  // matching VideoGrid's `hasVideo`, NOT its avatar gate `showInitial`, which also stands down
  // while the camera is starting. `!micOsMuted` is live-but-silent, not a failure (RISKS.md/P2.41).
  const hasAudio = isSelf
    ? (audioEnabled && !micUnavailable && !micOsMuted)
    : user.status.streams['camera'] ? !! user.status.streams['camera']['audio'] : false

  const hasVideo = isSelf
    ? (videoEnabled && !cameraUnavailable)
    : user.status.streams['camera'] ? !! user.status.streams['camera']['video'] : false

  const icons: { key: string, icon: IconInterface }[] = []
  // RISKS.md/P2.33: `isSelf ||` — a non-moderator's own `presence/admitted` is cleared on every
  // deliberate join, so their own tile would show no chips. The gate itself must stay:
  // SidebarParticipants must not chip invited-but-absent people.
  if (isSelf || (user.admitted && user.online)) {
    if (!hasVideo) icons.push({ key: 'video-off', icon: new SVGIcon('video-off') })
    if (!hasAudio) icons.push({ key: 'mic-off', icon: new SVGIcon('microphone-off') })
    if (typingUsers.includes(user.uuid)) icons.push({ key: 'typing', icon: new MaterialIcon('keyboard') })
  }

  return (
    <ul className={`user-status-symbols ${icons.length > 0}`}>
      {icons.map(({ key, icon }) => (
        <li key={key}>
          <span className="action-icon">
            {icon.get(true)}
          </span>
        </li>
      ))}
    </ul>
  )
}